"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartContractQueryResponse = exports.SmartContractQuery = void 0;
class SmartContractQuery {
    constructor(options) {
        this.contract = options.contract;
        this.caller = options.caller;
        this.value = options.value;
        this.function = options.function;
        this.arguments = options.arguments;
    }
}
exports.SmartContractQuery = SmartContractQuery;
class SmartContractQueryResponse {
    constructor(obj) {
        this.function = obj.function;
        this.returnCode = obj.returnCode;
        this.returnMessage = obj.returnMessage;
        this.returnDataParts = obj.returnDataParts;
    }
}
exports.SmartContractQueryResponse = SmartContractQueryResponse;
//# sourceMappingURL=smartContractQuery.js.map